import { ClientsStatusReport } from 'components/Report';
import { endpoints } from 'api';

function NewVerifiedClientsPage() {
    return (
        <ClientsStatusReport APIEndpoint={endpoints.NEW_VERIFIED_CLIENTS_REPORT} ReportName='New Verified Clients' />
    );
}
export default NewVerifiedClientsPage;
